import React from 'react';
import { Row } from 'react-bootstrap';

export const Section = ({ title, text, sectionType, children, sectionClass }) => {
	let wrapper;

	switch (sectionType) {
		case 'what-we-do':
			wrapper = (
				<section className={`what-we-do ${sectionClass}`}>
					<div className="auto-container">
						<div className="sec-title centered">
							<h4 className="subtitle">{text}</h4>
							<h2 dangerouslySetInnerHTML={{ __html: `${title}` }} />
						</div>

						<Row className="clearfix">
							{children}
						</Row>

					</div>
				</section>
			);
			break;

		case 'about-us':
			wrapper = (
				<section className={`about-us-section ${sectionClass}`}>
					<div className="auto-container">
						<Row className="clearfix">
							{children}
						</Row>
					</div>
				</section>

			);
			break;

		case 'products':
			wrapper = (
				<section className={`services-section ${sectionClass}`}>
					<div className="auto-container">
						<div className="sec-title centered">
							<h4 className="subtitle">{text}</h4>
							<h2 dangerouslySetInnerHTML={{ __html: `${title}` }} />
						</div>

						<Row className="clearfix">
							{children}
						</Row>

					</div>
				</section>
			);
			break;

		case 'office':
			wrapper = (
				<section className={`testimonials-section ${sectionClass}`}>
					<div className="auto-container">
						<Row className="clearfix">
							{children}
						</Row>
					</div>
				</section>
			);
			break;

		case 'project-steps':
			wrapper = (
				<section className={`work-process ${sectionClass}`}>
					<div className="auto-container">
						<div className="sec-title centered">
							<h4 className="subtitle">{text}</h4>
							<h2 dangerouslySetInnerHTML={{ __html: `${title}` }} />
						</div>

						<div className="steps-box">
							<Row className="clearfix">
								{children}
							</Row>
						</div>

					</div>
				</section>
			);
			break;

		case 'news':
			wrapper = (
				<section className={`news-section ${sectionClass}`}>
					<div className="auto-container">
						<div className="sec-title centered">
							<h4 className="subtitle">{text}</h4>
							<h2 dangerouslySetInnerHTML={{ __html: `${title}` }} />
						</div>

						<Row className="clearfix">
							{children}
						</Row>

					</div>
				</section>
			);
			break;
		case 'tabs':
			wrapper = (
				<section className={`pricing-section ${sectionClass}`}>
					<div className="auto-container">
						<div className="pricing-tabs">
							<div className="row clearfix">
								{children}
							</div>
						</div>
					</div>
				</section>
			);
			break;
		default:
			wrapper = (
				<section className={`about-section-three ${sectionClass}`}>
					<div className="auto-container">
						<div className="upper-title">
							<h1>{title}</h1>
							<div dangerouslySetInnerHTML={{ __html: `${text}` }} className="text" />
						</div>
						{children}
					</div>
				</section>
			);
	}

	return wrapper;
};



// WEBPACK FOOTER //
// ./src/components/ui/Section/Section.js